import { MinStaySettings } from '@common/api/minstay/types';

/**
 * Extracts min stay settings from pricing data, filtering out dates and rooms without min stay settings.
 * Properties are only included if they have valid values:
 * - min_stay is included only if it's not null/undefined
 * - is_skip_min_stay_rule is included only if it's true
 * @param dates Pricing data containing min stay settings
 * @returns Filtered object containing only dates and rooms with min stay settings
 */
export const extractMinStayDates = (dates: MinStaySettings['dates']): MinStaySettings['dates'] => {
  return Object.entries(dates).reduce<MinStaySettings['dates']>((acc, [date, rooms]) => {
    const roomsWithMinStay = Object.entries(rooms).reduce<
      Record<string, MinStaySettings['dates']['minstay']['rooms']>
    >((roomAcc, [roomId, roomData]) => {
      // Only include rooms that have min_stay or is_skip_min_stay_rule values
      if (roomData.min_stay != null || roomData.is_skip_min_stay_rule) {
        roomAcc[roomId] = {
          ...(roomData.min_stay != null && { min_stay: roomData.min_stay }),
          ...(roomData.is_skip_min_stay_rule && {
            is_skip_min_stay_rule: roomData.is_skip_min_stay_rule
          })
        };
      }
      return roomAcc;
    }, {});

    // Only include dates that have rooms with min stay settings
    if (Object.keys(roomsWithMinStay).length > 0) {
      acc[date] = roomsWithMinStay;
    }
    return acc;
  }, {});
};
